module.exports = __webpack_public_path__ + "Material-Design-Iconic-Font.d2a55d331bdd1a7ea97a.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/assets/fonts/Material-Design-Iconic-Font.woff?v=2.2.0
// module id = ../../../../../src/assets/fonts/Material-Design-Iconic-Font.woff?v=2.2.0
// module chunks = styles